import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the external terms and conditions
    window.location.href = "https://mystep-ai.info/legal/terms-and-conditions";
  }, []);

  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <Button
            variant="ghost"
            onClick={() => navigate(-1)}
            className="mb-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back
          </Button>
          <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
          <p className="text-muted-foreground">
            You are being redirected to our terms and conditions...
          </p>
          <p className="mt-4">
            If you are not redirected automatically,{" "}
            <a
              href="https://mystep-ai.info/legal/terms-and-conditions"
              className="text-primary underline"
            >
              click here
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;